import { RootRouteContentType, SyncResultStatus, WorkItemAction } from "@fusion-advantage/formlib"
import { err, ok } from "neverthrow"
import { setAppContent } from "../appSlice"
import { AppThunk } from "../appStore"
import { appSync } from "./syncThunk"
import { SyncType } from "./SyncConfig"
import { selectOpIsBlockingEncounterMgmt } from "../selectDashboardLoading"
import { SyncResult } from "./SyncResult"

interface adhocViewEncounterArgs {
	syncType: SyncType.Boot|SyncType.Dashboard
	encounterGuid: string
	action: WorkItemAction
	// optional: restrict view to only one page of the form
	onlyPageIdx?: number
	// opened from an /encounter/{guid} link (stricter write mode)
	openedFromLink?: boolean
}

export const adhocViewEncounter = ({syncType, encounterGuid, action, onlyPageIdx, openedFromLink}: adhocViewEncounterArgs): AppThunk<Promise<SyncResult>> => async (dispatch, getState) => {
	encounterGuid = encounterGuid.toUpperCase()
	if(selectOpIsBlockingEncounterMgmt(getState())) {
		alert('A sync is currently in progress; please try again when complete.')
		return err({ status: SyncResultStatus.Pending })
	}
	// immediately view form: online only
	// must sync supporting blobs
	const rSync = await dispatch(appSync({
		type: syncType,
		adhocEncounterGuid: encounterGuid,
		downloadPatchedRenderers: (action === WorkItemAction.ViewFormAsDocgen),
		// docgen runs headless in Gotenberg; nobody can answer a location prompt
		skipLocation: (action === WorkItemAction.ViewFormAsDocgen),
	}))
	if(rSync.isErr()) {
		// error has displayed
		// do nothing further
		return rSync
	}
	// open the loaded form
	dispatch(setAppContent({
		type: RootRouteContentType.Form,
		encounterGuid,
		action,
		onlyPageIdx,
		openedFromLink,
	}))
	return ok()
}
